


import { Link } from 'react-router-dom';
import Logo from '../../comps/appLogo';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import email from "../../data/imgs/icons/app/email.png";
import skills from '../../data/imgs/icons/app/skills.png';
import resume from '../../data/imgs/icons/app/resume.png';
import photos from '../../data/imgs/icons/app/photos.png';
import github from "../../data/imgs/icons/app/github.png";
import callMe from "../../data/imgs/icons/app/callMe.png";
import projects from '../../data/imgs/icons/app/projects.png';
import linkedIn from "../../data/imgs/icons/app/linkedIn.png";


const phoneNumber = "0548430352";
const emailAddress = "yoti1492@gmail.com";

import { cacheImageToLocalStorage } from '../../utils/utils';

export default () => {
  const [isLoading, setIsLoading] = useState(true);

  const saveImages = async () => {
    try {
      await Promise.all([
        cacheImageToLocalStorage(resume, 'resume'),
        cacheImageToLocalStorage(skills, 'skills'),
        cacheImageToLocalStorage(projects, 'projects'),
        cacheImageToLocalStorage(photos, 'photos'),
        cacheImageToLocalStorage(email, 'email'),
        cacheImageToLocalStorage(callMe, 'callMe'),
        cacheImageToLocalStorage(github, 'github'),
        cacheImageToLocalStorage(linkedIn, 'linkedIn')
      ]);
    } catch (error) {
      console.error('Error saving images:', error);
    } finally {
      setTimeout(() => setIsLoading(false), 100);
    }
  };

  useEffect(() => {
    saveImages();

    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVh();
    window.addEventListener('resize', setVh);

    return () => window.removeEventListener('resize', setVh);
  }, []);

  const resumeBase64 = sessionStorage.getItem('resume');
  const skillsBase64 = sessionStorage.getItem('skills');
  const projectsBase64 = sessionStorage.getItem('projects');
  const photosBase64 = sessionStorage.getItem('photos');
  const callMeBase64 = sessionStorage.getItem('callMe');
  const emailBase64 = sessionStorage.getItem('email');
  const githubBase64 = sessionStorage.getItem('github');
  const linkedInBase64 = sessionStorage.getItem('linkedIn');

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${type} copied to clipboard !`, {
        position: "bottom-center",
        autoClose: 2000
      });
    }, (err) => {
      toast.error(`Failed to copy ${type}`, {
        position: "bottom-center",
        autoClose: 2000
      });
    });
  };

  const renderLinkItem = (to, imgSrc, fallbackImg, altText, label, onClick = null, external = false) => {
    const LinkComponent = external ?
      ({ children }) => <a href={to} target="_blank" rel="noopener noreferrer" className="drop-link">{children}</a> :
      onClick ?
        ({ children }) => <Link className="drop-link" onClick={onClick}>{children}</Link> :
        ({ children }) => <Link className="drop-link" to={to}>{children}</Link>;

    return (
      <LinkComponent>
        <img src={imgSrc || fallbackImg} alt={altText} />
        <p style={{ fontWeight: 'bold', fontSize: '10px' }}>{label}</p>
      </LinkComponent>
    );
  };

  return (
    <>
      <div className="mobile-container">
        <div className="flex-center">
          <div className="search-container">
          <br />
            <Logo />
            {isLoading ? (
              <div className="loading-container">
                <div className="loader">
                  <div className="dot dot1"></div>
                  <div className="dot dot2"></div>
                  <div className="dot dot3"></div>
                </div>
              </div>
            ) : (
              <div className="drop-item-main">
                {renderLinkItem("/projects", projectsBase64, projects, "Projects", "Projects")}
                {renderLinkItem("/skills", skillsBase64, skills, "Skills", "Skills")}
                {renderLinkItem("/resume", resumeBase64, resume, "Resume", "Resume")}

                {renderLinkItem("/photos", photosBase64, photos, "Photos", "Photos")}
                {renderLinkItem("#", callMeBase64, callMe, "call", "Call", () => copyToClipboard(phoneNumber, 'Phone'))}
                {renderLinkItem("#", emailBase64, email, "email", "Email", () => copyToClipboard(emailAddress, 'Email'))}
                {renderLinkItem("https://www.linkedin.com/in/avraham-yom-tov-a74525231/", linkedInBase64, linkedIn, "LinkedIn", "LinkedIn", null, true)}
                {renderLinkItem("https://github.com/Avri-Here", githubBase64, github, "GitHub", "GitHub", null, true)}
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};



